<div class="tabbable__body rounded-top-right no-margin">
    <h3>
      Här kan du administrera maxuttag och lager för spelbolag
    </h3>

  @if (show.estimatesHaveChanged) {
      <import-warning></import-warning>
      <dot-loader [visibility]="show.updatingEstimates"></dot-loader>
  }

  <div class="container">
    <div class="left-item">
        @if (show.isEditing) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="gamblingEstimateShares.invalid"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button primary"
            (click)="setEditing(true)"
          >
            Redigera spelbolag
          </button>
        }
      </div>
      <div class="right-item">
        @if (productFormats?.length > 1) {
          <div class="filter-dropdown margin-left--2x dropdown">
            <woo-dropdown
              [items]="productFormats"
              [(ngModel)]="selectedProductFormat"
              name="selectedProductFormat"
              inputId="select-product-format"
              labelText="Filtrera på Placering"
              [labelTransform]="translateProductFormat"
              notFoundText="Inga Placeringar hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }

        @if (publishers?.length > 1) {
          <div class="filter-dropdown margin-left--2x dropdown">
            <woo-dropdown
              [items]="publishers"
              [(ngModel)]="selectedPublisher"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
      </div>
  </div>
  <div class="sticky-header">
      <h3>Maxuttag och lager för spelbolag</h3>
  </div>
  <p>
    <span class="text--info icon-warning"></span>
    OBS: Estimat anges i andel av totallagret som ska vara tillgängligt för spelbolagsbokningar.
  </p>

  <table
    class="table table-woo table--info table--hover width--100 sticky-head"
    ngForm
    #gamblingEstimateShares="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="4">Estimatfördelning</th>
        <th class="text-center" colspan="4">Maxuttag</th>
      </tr>
      <tr>
        @for (header of tableHeaders; let index = $index; track index) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of gamblingRows; let index = $index; track index) {
        <tr [hidden]="!rowVisible(row)">
          <td class="text--thin vertical-align--middle">
            <span>{{ row.publisher }}</span>
          </td>
          <td class="text--thin vertical-align--middle">
            <span>{{ translateProductFormat(row.productFormat) }}</span>
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.pauseAdShare | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPauseAdShare"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_pause_ad_share"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].pause_ad"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].pause_ad"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesPreroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPreroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limit_shares.preroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].preroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].preroll"
                  (ngModelChange)="autoFill(row, 'preroll')"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesMidroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesMidroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limit_shares.midroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].midroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].midroll"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesPostroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPostroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limit_shares.postroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].postroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].postroll"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.pausAdWithdrawalLimit | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-limitsPauseAdShare"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_pause_ad_withdrawal_limit"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].pause_ad"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].pause_ad"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-limitsPreroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limits.preroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].preroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].preroll"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-limitsMidroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limits.midroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].midroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].midroll"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-limitsPostroll"
                  [(ngModel)]="getGamblingProductFormat(row.productFormatId).gambling_withdrawal_limits.postroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="includedProductFormatSlotTypes[row.productFormatId].postroll"
                  [disabled]="!includedProductFormatSlotTypes[row.productFormatId].postroll"
                />
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="gamblingEstimateShares.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
</div>
